import { Icon } from 'ol/style';
import StyleFactory, { getPropFromFeature } from '../../StyleFactory';
const defaultIceBergIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjEwMPRyoQAAASJJREFUOE+FkL1KA1EQhe8TbG2x+ArpxICyFpIUInmEFJYW4hYWNom9uq3dlnYGQfCnWRCMWqW03EKt9xHG+S53wt4oa+Aws8N858yNExHXJefcSDVe3emEWNZfo9I2DvgvbTwYDmWz38ehaMN/giGlol5cFjJ/fQNEmcG/QN6TJIlfnEyn8vn17UWvs6oLrEgBNIj68PjErO4Cm7AUgcBpmi7PjU61M1niXe1E+uM8Byz9v72Mdq7H20hbBew7XNJE4Pr2wVE2GEXQ/cuHoLbRVrYra739widuHN6IqqKeXD3L+fW77J3eMatVi538Vs7KuRc9MwPLAC5CLQKEGTPEDsKsNpDFiWqmasIFLPNtpiTZZTMDccEdiIqR9cAAluj7H2xP6WikHHcfAAAAAElFTkSuQmCC';

function labelSelector(feature) {
  const value = getPropFromFeature('Type')(feature);

  if (value === '1') {
    return 'Outer Ice Berg Limit';
  }

  return null;
}

const iceBergPositionView = StyleFactory.createStyle({
  labelSelector,
  themeSelector: (value, theme) => ({
    stroke: {
      color: theme.color,
      width: 1
    }
  }),
  image: (feature, resolution, params, options) => new Icon({
    src: defaultIceBergIcon,
    ...(options && options.image)
  })
});
export default ((...args) => (feature, resolution, params) => {
  const {
    time
  } = params;
  const startTime = getPropFromFeature('StartTime')(feature);
  const endTime = getPropFromFeature('EndTime')(feature);
  return time >= new Date(startTime).getTime() && time < new Date(endTime).getTime() ? iceBergPositionView(...args)(feature, resolution, params) : null;
});